module.exports = __webpack_public_path__ + "img/IconSatisfied.23311458.svg";